import React, { useState, useRef } from "react";
import { Rnd } from "react-rnd";
import html2canvas from "html2canvas";

const PosterTemplateHorizontal = () => {
  const posterRef = useRef(null);

  const [elements, setElements] = useState([
    { id: 1, type: "text", content: "FULL TIME", x: 400, y: 50, fontSize: 24 },
    { id: 2, type: "text", content: "TEAM A", x: 100, y: 250, fontSize: 18 },
    { id: 3, type: "text", content: "TEAM B", x: 650, y: 250, fontSize: 18 },
    { id: 4, type: "text", content: "2 - 1", x: 400, y: 250, fontSize: 32 },
  ]);

  const [isDownloading, setIsDownloading] = useState(false);

  // ====== ADD IMAGE ======
  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (ev) => {
      setElements((prev) => [
        ...prev,
        {
          id: Date.now(),
          type: "image",
          src: ev.target.result,
          x: 50,
          y: 50,
          width: 120,
          height: 120,
        },
      ]);
    };
    reader.readAsDataURL(file);
  };

  // ====== ADD NEW TEXT ======
  const handleAddText = () => {
    setElements((prev) => [
      ...prev,
      {
        id: Date.now(),
        type: "text",
        content: "New Text",
        x: 200,
        y: 200,
        fontSize: 18,
      },
    ]);
  };

  // ====== CHANGE TEXT ======
  const handleChange = (id, value) => {
    setElements((prev) =>
      prev.map((el) => (el.id === id ? { ...el, content: value } : el))
    );
  };

  // ====== DELETE ELEMENT ======
  const handleDelete = (id) => {
    setElements((prev) => prev.filter((el) => el.id !== id));
  };

  // ====== DOWNLOAD ======
  const downloadPoster = async () => {
    setIsDownloading(true);
    await new Promise((r) => setTimeout(r, 300));
    if (!posterRef.current) return;

    const canvas = await html2canvas(posterRef.current, {
      backgroundColor: "#fff",
      scale: 2,
    });
    const dataUrl = canvas.toDataURL("image/png");

    const link = document.createElement("a");
    link.href = dataUrl;
    link.download = "poster.png";
    link.click();

    setIsDownloading(false);
  };

  return (
    <div>
      <div
        ref={posterRef}
        style={{
          width: "900px",
          height: "400px",
          margin: "20px auto",
          position: "relative",
          background: "#f8e26b",
          borderRadius: "12px",
          overflow: "hidden",
        }}
      >
        {elements.map((el) => (
          <Rnd
            key={el.id}
            default={{
              x: el.x,
              y: el.y,
              width: el.width || "auto",
              height: el.height || "auto",
            }}
            bounds="parent"
            enableResizing={el.type === "image"}
            style={{ cursor: "move" }}
          >
            <div style={{ position: "relative" }}>
              {el.type === "text" ? (
                isDownloading ? (
                  <div
                    style={{
                      fontSize: `${el.fontSize}px`,
                      fontWeight: "bold",
                      color: "#000",
                      textAlign: "center",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {el.content}
                  </div>
                ) : (
                  <input
                    type="text"
                    value={el.content}
                    onChange={(e) => handleChange(el.id, e.target.value)}
                    style={{
                      fontSize: `${el.fontSize}px`,
                      fontWeight: "bold",
                      border: "none",
                      background: "transparent",
                      color: "#000",
                      textAlign: "center",
                    }}
                  />
                )
              ) : (
                <img
                  src={el.src}
                  alt="uploaded"
                  style={{
                    width: el.width,
                    height: el.height,
                    objectFit: "contain",
                  }}
                />
              )}

              {/* Delete Button */}
              {!isDownloading && (
                <button
                  onClick={() => handleDelete(el.id)}
                  style={{
                    position: "absolute",
                    top: -10,
                    right: -10,
                    background: "red",
                    color: "white",
                    border: "none",
                    borderRadius: "50%",
                    width: 20,
                    height: 20,
                    cursor: "pointer",
                  }}
                >
                  ×
                </button>
              )}
            </div>
          </Rnd>
        ))}
      </div>

      {/* Control Buttons */}
      <div style={{ textAlign: "center", marginTop: "20px" }}>
        <input type="file" accept="image/*" onChange={handleImageUpload} />
        <button
          onClick={handleAddText}
          style={{
            padding: "10px 20px",
            fontSize: "16px",
            borderRadius: "8px",
            marginLeft: "10px",
          }}
        >
          Add Text
        </button>
        <button
          onClick={downloadPoster}
          style={{
            padding: "10px 20px",
            fontSize: "16px",
            borderRadius: "8px",
            marginLeft: "10px",
          }}
        >
          Download Poster
        </button>
      </div>
    </div>
  );
};

export default PosterTemplateHorizontal;